var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeLoan = function SvgHomeLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#homeLoan_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F2F7FF",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeLoan_svg__b)",
    d: "M26.883 16.35a1.25 1.25 0 0 0-1.737 0L11.377 27.317c-.372.35-.496.816-.248 1.283q.372.7 1.117.7h1.984v13.533c0 .584.496 1.167 1.24 1.167H36.56c.62 0 1.24-.583 1.24-1.167V29.3h1.985c.496 0 .992-.35 1.116-.7.248-.467 0-.933-.372-1.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeLoan_svg__c)",
    d: "M32.444 30.222a6.222 6.222 0 1 1-12.444 0 6.222 6.222 0 0 1 12.444 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.719 28.825c-.183-.627.122-1.38.793-1.568.61-.188 1.28.125 1.524.815a1.28 1.28 0 0 1-.793 1.568c-.67.188-1.341-.188-1.524-.815m1.585 4.892c-.305-.188-.366-.564-.244-.878l2.927-5.833c.183-.314.549-.44.854-.251.304.188.426.565.243.878l-2.926 5.833c-.183.314-.549.377-.854.251m4.634-.752c-.61.188-1.28-.126-1.524-.816a1.28 1.28 0 0 1 .792-1.568c.61-.188 1.342.125 1.525.816.182.69-.183 1.38-.793 1.568"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeLoan_svg__d)",
    d: "M42.525 40.946h-.001l-10.382 8.176a4.12 4.12 0 0 1-3.035.848l-13.992-1.672-3.728 1.354c-2.003-2.022-1.18-8.134-1.18-8.134l.888-.634a3.29 3.29 0 0 1 1.52-2.983q.172-.11.362-.201l6-2.877 3.086-1.48q.252-.12.514-.19c1.29-.347 2.69.21 3.35 1.404a2.85 2.85 0 0 1-1.07 3.843l-4.989 2.935 8.394 1.435a4.13 4.13 0 0 0 2.91-.584l8.348-5.32a2.6 2.6 0 0 1 3.428.57c.212.268.36.566.447.875a2.5 2.5 0 0 1-.87 2.635"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.854,
    height: 11.069,
    fill: "#3666B5",
    rx: 2.927,
    transform: "matrix(.9561 -.29305 .30302 .95298 3.74 41.643)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "homeLoan_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.16569 19.65711 -12.1638 -8.76572 30.551 22.087)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "homeLoan_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(137.911 11.3 18.592)scale(13.9258 12.5831)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "homeLoan_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-20.60887 14.90683 -16.0093 -22.13305 29.4 35.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "homeLoan_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgHomeLoan;